import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/admin/companies');
  }, [navigate]);

  return <div />;
};

export default AdminDashboard;
